var lib_core = require("lib-core");
var cio_config = require("cio-config");
var moment = require("moment");
var properties = require("cio-config").MetaProperties;

var TrayAssetSearchTabView = function(model, statemachine, rootStateMachine, parentView, parentName, config) {
    var self = this;

    this.model = model;
    this.statemachine = statemachine;
    this.rootStateMachine = rootStateMachine;
    this.parentView = parentView;
    this.parentName = parentName;

    this.config = config;

    //asset tray list view config
    this.viewConfig = config.viewConfig || {
        columns: [
        {   name: 'Name',
            key: 'name',
            isLink: true
        }, {
            name: 'Date',
            key: 'updated_at',
            location: 'right'
        }, {
            name: 'User',
            key: 'user_name',
            location: 'right'
        }, {
            name: 'Used',
            key: 'usage_count', //Need to confirm which key to be used (score or used)
            location: 'right'
        }],

        helpView: {
            enable: false, //disable for now
            message: {
                title: 'Can’t find what you are looking for?',
                expand: 'Expand your search to <a class="js-editor__tray__cannotfind__all_link">All</a> or <a class="js-editor__tray__cannotfind__create_link">create a new one</a>.',
                more_info: 'For more information, visit the <a class="js-editor__tray__cannotfind__doc_center">Documentation Center</a>.'
            }
        },

        enableAssetDetails: true,
        enableSorting: true,

        // TODO why is this hardcoded?  fix!
    };
 
    if (!this.model.url || !this.model.url())
        this.viewConfig.enableAssetDetails = false; // don't show "details" button if we don't know what URL to open when it's clicked.

    // TITLE
    this.titleTemplate = this.parentView.getTemplate().addTitle(this.model.title());
    this.titleTemplate.$el.on('Cioui:TrayTabTitle:clicked', function(e, val){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_ACTIVE_CHANGE)
            .data('tabName', self.model.name())
            .data('parentName', self.parentName)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    });

    // Attach template listeners
    this.attachListeners();

    // OBERVERS
    self.model.data.onChange(this, function(){
        self.showTabData(self);
    });

    self.model.template.onChange(this, function(){
        self.getTemplate().$el.off();
        self.getTemplate().$el.remove();
        self._template = false;
        self.showTabData(self);
        self.attachListeners();

        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_SWITCHER_BUTTON_CHANGE)
            .data('alternative_template', self.model.alternative_template())
            .data('parentName', self.parentName)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    });

    self.model.sorting.onChange(this, function(){
      
        self.getTemplate().setSortingKeyActive(self.model.sorting());
        self.getTemplate().setDropdown(self.model.sorting(), self.model.sorting_direction());
    });
    self.model.sorting_direction.onChange(this, function(val){
        self.getTemplate().flipSortingArrow(self.model.sorting(), val);
        self.getTemplate().setDropdown(self.model.sorting(), val);
    });

    function visibleUpdate(value){
        if(value){
            self.show();
            self.titleTemplate.setActive();
        }else{
            self.hide();
            self.titleTemplate.setInActive();
        }
    }
    self.model.visible.onChange(this, visibleUpdate);
    visibleUpdate(self.model.visible());
};

TrayAssetSearchTabView.prototype.getIsProp = function(myKey){
    for(var i = 0; i < this.viewConfig.columns.length; i++ ){
        if(myKey == this.viewConfig.columns[i].key){
            if(this.viewConfig.columns[i].isProperty) return true;
            else return false;
        }
    }
}

TrayAssetSearchTabView.prototype.attachListeners = function(){
    var self = this;

    // SORTING
    this.getTemplate().$el.on('Cioui:TrayTabItem:Sort:clicked', function(e, val){
        var isProp = self.getIsProp(val);
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_SORT)
            .data('tabName', self.model.name())
            .data('sortingKey', val)
            .data('isProp', isProp)
            .data('parentName', self.parentName)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    });

    this.getTemplate().$el.on('Cioui:TrayTabItem:SortDropdown:change', function(e, val){
        var isProp = self.getIsProp(val["sortkey"]);
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_SORT)
            .data('tabName', self.model.name())
            .data('sortingKey', val["sortkey"])
            .data('sortingDir', val["sortdirection"])
            .data('isProp', isProp)
            .data('parentName', self.parentName)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    });
};

TrayAssetSearchTabView.prototype.getTemplate = function(){
    if(!this._template){
        if(this.model.template() == "list"){
            this._template = this.parentView.getTemplate().addListComponentsInnerTray(this.viewConfig);
        }else if(this.model.template() == "grid"){
            this._template = this.parentView.getTemplate().addGridComponentsInnerTray(this.viewConfig);
        }else{
            console.error("ERROR: Unknown tray tab template");
        }
    }

    return this._template;
};

TrayAssetSearchTabView.prototype.showTabData = function(ref){
    var self = this;
    ref.getTemplate().clearContent();

    if(!ref.model.data()) return;

    if(ref.model.template() == "list") {
        ref.getTemplate().setTotalNumberOfResults(ref.model.numberOfResults());
        self.getTemplate().setSortingKeyActive(self.model.sorting());
        self.getTemplate().flipSortingArrow(self.model.sorting(), self.model.sorting_direction());
        self.getTemplate().setDropdown(self.model.sorting(), self.model.sorting_direction());
    }

    $.each(ref.model.data(), function(index, element){
        var updated_at = (element.updated_at || '');

        //format date and time in MON DD, YYYY HH:MM AM/PM
        if(updated_at) {
            updated_at = moment(updated_at).format('MMMM DD, YYYY hh:mm A');
        }
        
        var asset_url = (self.model.url && self.model.url()) ? self.model.url() + "?assetid=" + element.id : "";

        var thumbnail = element.thumbnail;

        var defaults = {
            "name": (element.name || ''),
            "thumb_url": (thumbnail || ''),
            "updated_at": updated_at,
            "user_name": (element.user_name || ''),
            "usage_count": element.usage_count || 0,
            "description": ((!element.summary)? element.description : element.summary),
            "alias": (element.alias || ''),
            "hub": element.hub_name
        }

        function format(data, propInfo){
            if(propInfo.type){
                data = propInfo.type.parser(data)
                console.assert(data, "Warning! There is bad data in this property! This could be a hacking attept?");
            }
            if(propInfo.unit){
                data = cio_config.UnitConversions.convert("um", propInfo.unit, data);
                data = data + '' + propInfo.unit;
            }
            return data;
        }

        // find the groups
        var groups = {};
        var props = properties[self.model.parent().type()];
        for(var key in props){
            if(props.hasOwnProperty(key)){
                var group = props[key].group;
                var id = props[key].serverName;
                if(groups[group] == undefined){
                    groups[group] = {}
                }
                if(element.properties && element.properties[id]){
                    groups[group][id] = format(element.properties[id], props[key]);
                } else {
                    groups[group][id] = 'n/a';
                }
            }
        }

           // convientient if developers want to just display all properties of an asset
        var all = {}
        for(var key in props){
            if(props.hasOwnProperty(key)){
                var id = props[key].serverName;
                if(element.properties && element.properties[id]){
                    all[id] = format(element.properties[id], props[key]);
                } else {
                    all[id] = 'n/a';
                }
            }
        }

        if(!self.config.overlayGroup){
            var component = ref.getTemplate().addItem(defaults, all, self.config.overlay);
        } else {
            var component = ref.getTemplate().addItem(defaults, groups[self.config.overlayGroup], self.config.overlay);
        }

        component.$el.on('Cioui:TrayTabItem:clicked', function(e, val){
            var lastVersion = element.getLastVersion();
            var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.NODE_MOUSE_DOWN)
                .data('type', ref.model.parent().type())
                .data('content_server_id', element.id)
                .data('version', lastVersion ? lastVersion.version : null)
                .data('name', element.name)
                .scope(self.model.scope());
            ref.model.parent().parent().visible(false); // TODO: violation of MVC!!!!
            ref.rootStateMachine.handle(cEvent);
        });

        if (asset_url) {
            component.$el.on('Cioui:TrayTabItem:detailsClicked', function(e) {
                var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.OPEN_URL_IN_NEW_WINDOW)
                    .data('url', asset_url);
                ref.rootStateMachine.handle(cEvent);
            });
        }
    });
};


TrayAssetSearchTabView.prototype.show = function(){
    this.getTemplate().show();
};

TrayAssetSearchTabView.prototype.hide = function(){
    this.getTemplate().hide();
};

module.exports = TrayAssetSearchTabView;

